import React from 'react';
import classnames from 'classnames';
import Section from '@latitude/section';
import './_callout-box.scss';

type Props = {
  className?: string,
  title: string,
  titleTag: string,
  image: React.node,
  desc: string | React.node,
  cta: React.node
};

const defaultProps = {
  titleTag: 'h4'
};

const CalloutBox = (props: Props) => {
  const className = classnames('callout-box', props.className);

  return (
    <Section id={props.id} className={className}>
      <div className="callout-box__inner bg-light-blue d-md-flex">
        <div className="callout-box__image d-none d-md-block">
          {props.image}
        </div>
        <div className="callout-box__body">
          <div className="callout-box__title-wrap">
            <props.titleTag className="text-center text-md-left m-0">
              {props.title}
            </props.titleTag>
          </div>

          {props.image && (
            <div className="callout-box__image d-md-none ml-auto mr-auto text-center">
              {props.image}
            </div>
          )}

          <p className="callout-box__desc">{props.desc}</p>

          {props.cta && (
            <div className="callout-box__cta-wrap">{props.cta}</div>
          )}
        </div>
      </div>
    </Section>
  );
};

CalloutBox.defaultProps = defaultProps;

export default CalloutBox;
